<div class="container-fluid py-2">
  <!-- Statistics -->
  <div class="row">
    <!-- Plan -->
    <div class="col-lg-4">
      <div class="card shadow-sm">
        <div class="card-header bg-primary text-white">
          <h5 class="mb-0"> Customized Package </h5>
        </div>
        <div class="card-body">

  <div class="row g-3 mb-4">
    <div class="col-6">
      <div class="card stat-card">
        <div class="card-body">
          <div class="d-flex justify-content-center">
            <div>
              <small>Current<br>Package / Plan</small>
              <h5>{{plan.packageName}}</h5>
            </div>
            <!-- <i class="bi bi-box-seam"></i> -->
          </div>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="card stat-card">
        <div class="card-body">
          <div class="d-flex justify-content-center">
            <div>
              <small>Activated<br>Modules</small>
              <h5>{{activeModules}}</h5>
            </div>
            <!-- <i class="bi bi-grid"></i> -->
          </div>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="card stat-card">
        <div class="card-body">
          <div class="d-flex justify-content-center">
            <div>
              <small>Active<br>Institutes</small>
              <h5>{{inactiveModules}}</h5>
            </div>
            <!-- <i class="bi bi-x-circle"></i> -->
          </div>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="card stat-card">
        <div class="card-body">
          <div class="d-flex justify-content-center">
            <div>
              <small>License<br>Purchased</small>
              <h5 class="text-success">{{plan.status}}</h5>
            </div>
            <!-- <i class="bi bi-patch-check-fill"></i> -->
          </div>
        </div>
      </div>
    </div>
  </div>

          <!-- <table class="table table-borderless">
            <tr>
              <th>Organization</th>
              <td>{{plan.organization}}</td>
            </tr>
            <tr>
              <th>Package</th>
              <td>{{plan.packageName}}</td>
            </tr>
            <tr>
              <th>Plan</th>
              <td>{{plan.planType}}</td>
            </tr>
            <tr>
              <th>Amount</th>
              <td>{{plan.amount}}</td>
            </tr>
            <tr>
              <th>Activated</th>
              <td>{{plan.activatedOn}}</td>
            </tr>
            <tr>
              <th>Expiry</th>
              <td>{{plan.expiry}}</td>
            </tr>
            <tr>
              <th>License</th>
              <td>{{plan.licenseKey}}</td>
            </tr>
          </table> -->
          <hr>
          <label class="fw-semibold"> Users </label>
          <div class="progress mb-3">
            <div class="progress-bar" [style.width.%]="plan.usedUsers*100/plan.maxUsers">
            </div>
          </div>
          {{plan.usedUsers}} / {{plan.maxUsers}}
          <label class="fw-semibold mt-3"> Storage </label>
          <div class="progress mb-3">
            <div class="progress-bar bg-success" [style.width.%]="plan.usedStorage*100/plan.storage">
            </div>
          </div>
          {{plan.usedStorage}} GB / {{plan.storage}} GB
        </div>
      </div>
    </div>
    <!-- Modules -->
    <div class="col-lg-8">
      <div class="card shadow-sm">
        <div class="card-header">
          <div class="row">
            <div class="col-md-6">
              <input class="form-control" [(ngModel)]="search" placeholder="Search Module">
            </div>
            <div class="col-md-6">
              <select class="form-select" [(ngModel)]="category">
                <ng-container *ngFor="let c of categories">
                <option value="{{c.code}}">{{c.name}}</option>
                </ng-container>
              </select>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-lg-6 mb-3" *ngFor="let m of filteredModules">
              <div class="card h-100 module-card">
                <div class="card-body">
                  <div class="d-flex justify-content-between">
                    <div>
                      <h5>
                        {{m.module}}
                      </h5>
                      <small>
                        {{dataService.getDeptName(m.category)}}
                      </small>
                    </div>
                    <span class="badge" [class.bg-success]="m.enabled" [class.bg-secondary]="!m.enabled">
                      {{m.enabled?'Enabled':'Disabled'}}
                    </span>
                  </div>
                  <hr>
                  <p>
                    {{m.description}}
                  </p>
                  <p> Active Users : <b>{{m.users}}</b>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>